import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import CompetencyTypeForm from '../../../components/forms/CompetencyTypeForm';
import { useCreateCompetencyType } from '../../../hooks/useCompetencyTypeApi';
import { useNavigate } from 'react-router-dom';
import { CompetencyTypeDTO } from '../../../services/apiClient';

const CompetencyTypeCreate: React.FC = () => {
  const createCompetencyType = useCreateCompetencyType();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Competency Types', href: '/admin/competencytypes' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: CompetencyTypeDTO) => {
    try {
      setIsSubmitting(true);
      await createCompetencyType.mutateAsync(data);
      navigate(-1);
    } catch (error) {
      console.error('Error creating CompetencyType:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/competencytypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.CompetencyType.Edit"
    >
      <CompetencyTypeForm
        initialValues={{} as CompetencyTypeDTO}
        onSubmit={handleSubmit}
        onCancel={() => navigate(-1)}
        isLoading={isSubmitting}
      />
    </AdminLayout>
  );
};

export default CompetencyTypeCreate;
